// extracted by mini-css-extract-plugin
export default {"container":"RedirectPopupStatus_container__GaU7j","loading-button":"RedirectPopupStatus_loading-button__n72ah"};